import { styled } from '@mui/material';
import Button from '../Button/Button.js';
import '../Button/SplitButton.js';

const PercentageSpan = styled('span') `
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  background-color: ${({ theme }) => theme.palette.N40.main};
  color: ${({ theme }) => theme.palette.N10.main};
  padding-left: 5px;
  padding-right: 5px;
  font-weight: 700;
  letter-spacing: 0.6px;
  font-family: 'opensans-bold';
`;
const ControlButton = styled(Button, {
    shouldForwardProp: prop => !prop.toString().startsWith('$'),
}) `
  padding: 10px;
  background-color: ${({ theme }) => theme.palette.N40.main};
  color: ${({ theme }) => theme.palette.N10.main};
  font-weight: 700;

  ${({ $removeBorderRadiusOnRightSide }) => $removeBorderRadiusOnRightSide &&
    `
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      `}

  ${({ $removeBorderRadiusOnLeftSide }) => $removeBorderRadiusOnLeftSide &&
    `
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      `}
  
    &:hover {
    color: white;
    background-color: ${({ theme }) => theme.palette.N30.main};
  }

  &.Mui-disabled {
    background-color: ${({ theme }) => theme.palette.N50.main};
    color: ${({ theme }) => theme.palette.N30.main};
  }
`;
const ZoomControlWrapper = styled('div') `
  display: flex;
`;

export { ControlButton, PercentageSpan, ZoomControlWrapper };
//# sourceMappingURL=styled.js.map
